import { SimpleFormFlowHierarchyAttribute } from '../../../../Models/SimpleFormFlowHierarchyAttribute';

export class LocationAttribute {
    LocationAttributeId: string;
    AttributeName: string;
    DefaultName: string;
    GroupName: string;
    MultiFieldName: string;
    AttributeId: string;
    AttributeUniqueId: string;
    AttributeType: string;
    IsMandatory: boolean;
    HelpText: string;
    DefaultDescription: string;
    ListType: string;
    ListAlias: string;
    IsOfType: string;
    IsCustomField: boolean;
    OriginalFieldId: string;
    IsMultiLine: boolean;
    HasTime: boolean;
    index: number;
    IsAlwaysHidden: boolean;
    Modified: boolean;
    VisibleWhenOrRules: ValueIsProperty[];
    MandatoryWhenOrRules: ValueIsProperty[];
    HideWhenOrRules: ValueIsProperty[];
    VisibleWhenRules: ValueIsProperty[];
    MandatoryWhenRules: ValueIsProperty[];
    HideWhenRules: ValueIsProperty[];
    ListParams: any[];
    Json: string;
    Order: number;
    ListValueType: 'AIRSWEBLIST';
    AutoFillDefinition: AutoFillDefinition;
    CalculationType: number;
    MaxChars: number;
    MinChars: number;
    DrivingField: SimpleFormFlowHierarchyAttribute;
    DrivingAttribute: string;
    IsDeactivated: boolean;
    RegexRestrict: string;

    static getVisibilityRuleState(field: LocationAttribute, type: any, listAlias: string): boolean {
        return (field.VisibleWhenOrRules && (field
            .VisibleWhenOrRules
            .filter((r: ValueIsProperty) => {
                return r.PropertyName === listAlias && (r.ValueIs.Value === type.Value || r.ValueIs.Identifier === type.Value);
            }).length > 0))

            ||

            (field.VisibleWhenRules && (field
                .VisibleWhenRules
                .filter((r: ValueIsProperty) => {
                    return r.PropertyName === listAlias && (r.ValueIs.Value === type.Value || r.ValueIs.Identifier === type.Value);
                }).length > 0));
    }

    static getHideRuleState(field: LocationAttribute, type: any, listAlias: string): boolean {
        return (field.HideWhenOrRules && (field
            .HideWhenOrRules
            .filter((r: ValueIsProperty) => {
                return r.PropertyName === listAlias && (r.ValueIs.Value === type.Value || r.ValueIs.Identifier === type.Value);
            }).length > 0))

            ||

            (field.HideWhenRules && (field
                .HideWhenRules
                .filter((r: ValueIsProperty) => {
                    return r.PropertyName === listAlias && (r.ValueIs.Value === type.Value || r.ValueIs.Identifier === type.Value);
                }).length > 0));
    }

    static toggleHideRuleState(field: LocationAttribute, type: any, listAlias: string, isBooleanField: boolean = false) {
        field.HideWhenRules = field.HideWhenRules || [];
        field.HideWhenOrRules = field.HideWhenOrRules || [];
        const allRules = field.HideWhenRules.concat(field.HideWhenOrRules);
        const existing = allRules.find(r => r.PropertyName === listAlias && r.ValueIs.Value === type.Value);

        if (existing) {
            allRules.splice(allRules.indexOf(existing), 1);
        } else {
            const newProp = new ValueIsProperty();
            newProp.PropertyName = listAlias;
            newProp.ValueIs = new ValueIs();
            if (isBooleanField) {
                newProp.ValueIs.Identifier = type.Value;
                newProp.ValueIs.Value = null;
            } else {
                newProp.ValueIs.Value = type.Value;
                newProp.ValueIs.Identifier = 'value_string';
            }
            allRules.push(newProp);
        }

        if (allRules.length === 0) {
            field.HideWhenOrRules = [];
            field.HideWhenRules = [];
        } else if (allRules.length === 1) {
            field.HideWhenRules = allRules;
            field.HideWhenOrRules = [];
        } else {
            field.HideWhenOrRules = allRules;
            field.HideWhenRules = [];
        }
    }

    static toggleVisibilityRuleState(field: LocationAttribute, type: any, listAlias: string, isBooleanField: boolean = false) {
        const allRules = field.VisibleWhenRules.concat(field.VisibleWhenOrRules);
        const existing = allRules.find(r => r.PropertyName === listAlias && r.ValueIs.Value === type.Value);

        if (existing) {
            allRules.splice(allRules.indexOf(existing), 1);
        } else {
            const newProp = new ValueIsProperty();
            newProp.PropertyName = listAlias;
            newProp.ValueIs = new ValueIs();
            if (isBooleanField) {
                newProp.ValueIs.Identifier = type.Value;
                newProp.ValueIs.Value = null;
            } else {
                newProp.ValueIs.Value = type.Value;
                newProp.ValueIs.Identifier = 'value_string';
            }
            allRules.push(newProp);
        }

        if (allRules.length === 0) {
            field.VisibleWhenOrRules = [];
            field.VisibleWhenRules = [];
        } else if (allRules.length === 1) {
            field.VisibleWhenRules = allRules;
            field.VisibleWhenOrRules = [];
        } else {
            field.VisibleWhenOrRules = allRules;
            field.VisibleWhenRules = [];
        }
    }

    static getMandatoryRuleState(field: LocationAttribute, type: any, listAlias: string): boolean {
        return (field.MandatoryWhenOrRules && field
            .MandatoryWhenOrRules
            .filter((r: ValueIsProperty) => {
                return r.PropertyName === listAlias && (r.ValueIs.Value === type.Value || r.ValueIs.Identifier === type.Value);
            }).length > 0)

            ||

            (field.MandatoryWhenRules && field
                .MandatoryWhenRules
                .filter((r: ValueIsProperty) => {
                    return r.PropertyName === listAlias && (r.ValueIs.Value === type.Value || r.ValueIs.Identifier === type.Value);
                }).length > 0);
    }

    static toggleMandatoryRuleState(field: LocationAttribute, type: any, listAlias: string, isBooleanField: boolean = false) {
        const allRules = field.MandatoryWhenRules.concat(field.MandatoryWhenOrRules);
        const existing = allRules.find(r => r.PropertyName === listAlias && r.ValueIs.Value === type.Value);

        if (existing) {
            allRules.splice(allRules.indexOf(existing), 1);
        } else {
            const newProp = new ValueIsProperty();
            newProp.PropertyName = listAlias;
            newProp.ValueIs = new ValueIs();
            if (isBooleanField) {
                newProp.ValueIs.Identifier = type.Value;
                newProp.ValueIs.Value = null;
            } else {
                newProp.ValueIs.Value = type.Value;
                newProp.ValueIs.Identifier = 'value_string';
            }
            allRules.push(newProp);
        }

        if (allRules.length === 0) {
            field.MandatoryWhenOrRules = [];
            field.MandatoryWhenRules = [];
        } else if (allRules.length === 1) {
            field.MandatoryWhenRules = allRules;
            field.MandatoryWhenOrRules = [];
        } else {
            field.MandatoryWhenOrRules = allRules;
            field.MandatoryWhenRules = [];
        }
    }
}

export class ValueIs {
    Identifier: string;
    Value: any;
}

export class ValueIsProperty {
    ValueIs: ValueIs;
    PropertyName: string;
}

export class AutoFillDefinition {
    DefaultName: string;
    LookupTableName: string;
    EnabledWhen: {};
    PreviewFields: any;
    ControlValueMappings: any;
}